// extracted by mini-css-extract-plugin
export default {"logo":"appLogo_logo__6+qiy"};